import React from 'react';

// Shared, state-independent helpers used across the duty-roster components.
export const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().split(/\s+/).slice(0, 2).map(p => p[0]?.toUpperCase()).join('') || '?';
};

// Display-only HH:MM (roster times are stored with seconds, e.g. "08:00:00").
export const hhmm = (t) => (t ? String(t).slice(0, 5) : t);

export const InitialsAvatar = ({ name, size = 'sm' }) => {
    const sizes = { sm: 'w-6 h-6 text-[8px]', md: 'w-10 h-10 text-[13px]', lg: 'w-14 h-14 text-[18px]' };
    return (
        <div className={`${sizes[size]} rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center font-black shrink-0`}>
            {getInitials(name)}
        </div>
    );
};
